"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECivility = void 0;
exports.ECivility = {
    monsieur: "monsieur",
    madame: "madame",
    non_communique: "non_communique",
};
